module.exports = __webpack_public_path__ + "img/kolkin-logo-black.47df6dde.png";